//region block: pre-declaration
//endregion
function isOtherUppercase(_this__u8e3s4) {
  return (8544 <= _this__u8e3s4 ? _this__u8e3s4 <= 8559 : false) || (9398 <= _this__u8e3s4 ? _this__u8e3s4 <= 9423 : false);
}
//region block: exports
export {
  isOtherUppercase as isOtherUppercase3n31j7fretq60,
};
//endregion

//# sourceMappingURL=_OtherUppercaseChars.mjs.map
